angular.module('common.directives').directive('eventDashboard', function () {
  return {
    scope: {
      edge: '='
    },
    templateUrl: './templates/eventDashboard.view.html?t=' + webpackHash,
    link: function ($scope, $element) {},
    controller: 'eventsDashboardController'
  }
})
